module.exports = __webpack_public_path__ + "static/intelex-logo-cf63aa67528cb67846953e89c461c065.png";